import styled from "@rentiohq/web-theme";

export const Wrap = styled.div`
  border: 2px solid cyan;
  background-color: rgba(0, 255, 255, 0.1);
  padding: ${({ theme }) => theme.spacing("extraTight")};
  margin: ${({ theme }) => theme.spacing("extraTight")};
`;

export const SeeMoreButton = styled.div`
  cursor: pointer;
  color: teal;
  margin-top: ${({ theme }) => theme.spacing("extraTight")};
`;
